import { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import i18n from './i18n';
import './css/App.css';
import Home from './components/pages/Home';
import Header from './components/blocks/Header';
import Footer from './components/blocks/Footer';
import Packages from './components/pages/Packages';
import PackageInfo from './components/pages/PackageInfo';
import Booking from './components/pages/Booking';
import BucketList from './components/pages/BucketList';
import { DContext } from './context/DataContext';
import AboutUs from './components/pages/AboutUs';
import Terms from './components/pages/Terms';
import Carousel from './components/blocks/Carousel';
import PaymentForm from './components/pages/Payments';
import LoadingPage from './components/pages/Loading';
import Login from './components/pages/Login';
import HeaderOffCanvas from './components/blocks/HeaderOffCanvas';
import Register from './components/pages/Register';
import ForgotPassword from './components/pages/ForgotPassword';
import ResetPassword from './components/pages/ResetPassword';
import Loading from './components/blocks/Loading';
import Account from './components/pages/Account';
import AdminDashboard from './components/pages/Admin/Dashboard';
import Users from './components/pages/Admin/Users';
import User from './components/pages/Admin/User';
import CreatePackage from './components/pages/Admin/CreatePackage';
import ManagePackages from './components/pages/Admin/ManagePackages';
import PackageDetails from './components/pages/Admin/ViewPackage';
import UpdatePackage from './components/pages/Admin/UpdatePackage';
import NoAccess from './components/pages/NoAccess';
import Bookings from './components/pages/Admin/Bookings';
import ViewBooking from './components/pages/Admin/ViewBooking';
import Orders from './components/pages/Orders';
import AdminLayout from './components/layouts/AdminLayout';
import VideoAd from './components/pages/Admin/VideoAd';

function App() {


  const { ln, setLn, isAuth, currentUser, Loader } = useContext(DContext)

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLn(lng)
  };


  const location = useLocation();
  const [path, setPath] = useState(location.pathname)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const isAdminUser = isAuth && currentUser?.role === 'admin';
  const isAdminRoute = path.startsWith('/admin');
  const showGlobalShell = !isAdminRoute && !(isAdminUser && path === '/');
  const showGlobalHeader = showGlobalShell && path !== '/';

  useEffect(() => {
    const containerElement = document.getElementById("container-element")

    if (containerElement) {
      containerElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
    if (location.pathname)
      setPath(location.pathname)

    setIsMobileMenuOpen(false)

  }, [location.pathname]);

  const handleAdminRoute = (Component) => {
    if (isAuth) {
      if (currentUser.role === "admin") {
        return Component
      }
      else {
        return <NoAccess />
      }
    }
    return <Login />
  }

  const handleUserRoute = (Component) => {
    if (isAuth) {
      return Component
    }
    else {
      return <Login />
    }
  }

  if (isAuth === null || currentUser === null || !path) {
    return <LoadingPage />
  }

  console.log("Current User: ", isAuth === null)
  console.log("/:", path === '/')
  return (
    <div className='relative w-full p-0' id='container-element'>
      {showGlobalHeader && <Header ln={ln} changeLanguage={changeLanguage} setIsMobileMenuOpen={setIsMobileMenuOpen} />}
      <Routes>
        <Route path='/' element={isAdminUser ? <Navigate to="/admin" replace /> : <Home />} />


        {/* Admin Routes */}
        <Route element={handleAdminRoute(<AdminLayout />)}>
          <Route path='admin' element={<AdminDashboard />} />
          <Route path='admin/users' element={<Users />} />
          <Route path='admin/user/:id' element={<User />} />
          <Route path='admin/manage-packages' element={<ManagePackages />} />
          <Route path='admin/create-package' element={<CreatePackage />} />
          <Route path='admin/update-package/:id' element={<UpdatePackage />} />
          <Route path='admin/packages/:id' element={<PackageDetails />} />
          <Route path='admin/manage-bookings' element={<Bookings />} />
          <Route path='admin/booking/:id' element={<ViewBooking />} />
          <Route path='admin/video-ad' element={<VideoAd />} />
        </Route>

        <Route path='/packages' element={<Packages />} />
        <Route path='/bucket-list' element={<BucketList />} />
        <Route path='/booking' element={<Booking />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/package/:packagePath' element={<PackageInfo />} />
        <Route path='/booking/:packagePath' element={handleUserRoute(<Booking />)} />
        <Route path='/user-bookings' element={<Orders />} />
        <Route path='/terms-privacy' element={<Terms />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />

        {/* User Routes */}
        <Route path='/account' element={handleUserRoute(<Account />)} />

        <Route path='/st' element={<Carousel />} />
        <Route path='/payments' element={<PaymentForm />} />



      </Routes>
      {showGlobalShell && <Footer />}

      {showGlobalHeader && <HeaderOffCanvas ln={ln} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />}

      {Loader && <Loading />}
    </div>
  )



}

export default App;
